export const cookiesTokenName = "access_token";
export const cookiesRefreshTokenName = "refresh_token";

const AllFilterOptions = { value: "", label: "All" }
export const DEFAULT_IMAGE_URL = "@/assets/images/not-found.png";

export const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
};

export const getYearMonthString = (date) => {
    if (!date) return "";
    const currentDate = new Date(date);
    if (isNaN(currentDate)) return "";
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
    return `${year}-${month}`;
};

export const removeEmptyFields = (passData) => {
    Object.keys(passData).forEach(key => {
        const value = passData[key];
        if (value instanceof File) {
            return;
        }
        if (
            value === null ||
            value === undefined 
        ) {
            delete passData[key];
        }
        // If value is an empty array, do not delete
        else if (Array.isArray(value)){
            value.forEach(v => removeEmptyFields(v)); // remove empty field when have object inside arrays
        } 
    });
    return passData;
};

export const jsonToFormData = (json) => {
    const formData = new FormData();
    const appendFormData = (data, root = "") => {
        Object.entries(data).forEach(([key, value]) => {
            const formKey = root ? `${root}[${key}]` : key;
            if (value instanceof File) {
                formData.append(formKey, value);
            } else if (value instanceof Blob) {
                formData.append(formKey, value, value.name || "blob");
            } else if (Array.isArray(value)) {
                if (value.length === 0) {
                    formData.append(formKey, '');
                } else {
                    value.forEach((item, idx) => {
                        appendFormData({ [idx]: item }, formKey);
                    });
                }
            } else if (value !== null && typeof value === "object") {
                appendFormData(value, formKey);
            } else if (value !== undefined) {
                formData.append(formKey, value);
            }
        });
    };
    appendFormData(json);
    return formData;
};

export const REVIEW_STATUS = {
    PENDING: "pending",
    APPROVED: "approved",
    REJECTED: "rejected"
};

export const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case REVIEW_STATUS.PENDING:
            return 'warning';
        case REVIEW_STATUS.APPROVED:
            return 'success';
        case REVIEW_STATUS.REJECTED:
            return 'error';
        default:
            return 'secondary';
    }
};

export const STATUS_ACTIVE = 10;
export const STATUS_INACTIVE = 100;
export const STATUS_SUSPENDED = 90;

export const USER_ROLE = {
    ADMIN: 1,
    TECHNICIAN: 2,
    OPERATOR: 3,
    STOCKER: 4,
    MANAGER: 5
};

export const getRoleFilters = (includeAll = false) => {
    const filters = [
        { value: USER_ROLE.TECHNICIAN, label: "Technician" },
        { value: USER_ROLE.OPERATOR, label: "Operator" },
        { value: USER_ROLE.STOCKER, label: "Staff Member" },
        { value: USER_ROLE.MANAGER, label: "Manager" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const getStaffStatusFilters = (includeAll = false) => {
    const filters = [
        { value: STATUS_ACTIVE, label: "Active" },
        { value: STATUS_SUSPENDED, label: "Suspended" },
        { value: STATUS_INACTIVE, label: "Terminated" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const getStatusFilters = () => {
    const filters = [
        { value: STATUS_ACTIVE, label: "Active" },
        { value: STATUS_INACTIVE, label: "Inactive" },
    ];
    return filters;
};

export const STATES = [
    { value: 1, label: "Johor" },
    { value: 2, label: "Kedah" },
    { value: 3, label: "Kelantan" },
    { value: 4, label: "Melaka" },
    { value: 5, label: "Negeri Sembilan" },
    { value: 6, label: "Pahang" },
    { value: 7, label: "Perak" },
    { value: 8, label: "Perlis" },
    { value: 9, label: "Penang" },
    { value: 10, label: "Selangor" },
    { value: 11, label: "Terengganu" },
    { value: 12, label: "Sabah" },
    { value: 13, label: "Sarawak" },
    { value: 14, label: "Kuala Lumpur" },
    { value: 15, label: "Putrajaya" }
];

export const getChecklistCategories = (includeAll = false) => {
    const filters = [
        { value: CATEGORY_MAINTENANCE, label: "Maintenance" },
        { value: CATEGORY_TRANSPORTATION, label: "Transportation" },
        { value: CATEGORY_ASSEMBLY, label: "Assembly" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};


export const TYPE_DAILY = 1;
export const TYPE_MONTHLY = 2;
export const TYPE_ANNUALLY = 3;
export const TYPE_WEEKLY = 4;

export const CATEGORY_MAINTENANCE = 1;
export const CATEGORY_TRANSPORTATION = 2;
export const CATEGORY_ASSEMBLY = 3;


export const getFrequencyFilters = (includeAll = false) => {
    const filters = [
        { value: TYPE_DAILY, label: "Daily" },
        { value: TYPE_WEEKLY, label: "Weekly" },
        { value: TYPE_MONTHLY, label: "Monthly" },
        { value: TYPE_ANNUALLY, label: "Annually" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return "0 KB";

    const mb = bytes / (1024 * 1024);
    if (mb >= 1) {
        return `${mb.toFixed(2)} MB`;
    }

    const kb = bytes / 1024;
    return `${kb.toFixed(2)} KB`;
};

export const FREQ_ONCE = 1;
export const FREQ_DAILY = 2;
export const FREQ_WEEKLY = 3;
export const FREQ_MONTHLY = 4;

export const getPMFrequencyFilters = (includeAll = true) => {
    const filters = [
        { value: FREQ_ONCE, label: "Once" },
        { value: FREQ_DAILY, label: "Daily" },
        { value: FREQ_WEEKLY, label: "Weekly" },
        { value: FREQ_MONTHLY, label: "Monthly" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const getPMFrequency = (idx) => {
    switch (idx) {
        case FREQ_ONCE:
            return "Once";
        case FREQ_DAILY:
            return "Daily";
        case FREQ_WEEKLY:
            return "Weekly";
        case FREQ_MONTHLY:
            return "Monthly";
        default:
            return "Unknown";
    }
}


export const PROGRESS_OPEN = 1;
export const PROGRESS_ON_HOLD = 2;
export const PROGRESS_IN_PROGRESS = 3;
export const PROGRESS_IN_REVIEW = 4;
export const PROGRESS_WAITING_PARTS = 5;
export const PROGRESS_WAITING_COST = 6;
export const PROGRESS_WAITING_INVOICE = 7;
export const PROGRESS_COMPLETED = 8;

export const PROGRESS_STATUS = {
    [PROGRESS_OPEN]: 'Open',
    [PROGRESS_ON_HOLD]: 'On Hold',
    [PROGRESS_IN_PROGRESS]: 'In Progress',
    [PROGRESS_IN_REVIEW]: 'In Review',
    [PROGRESS_WAITING_PARTS]: 'Waiting For Parts',
    [PROGRESS_WAITING_COST]: 'Waiting For Cost',
    [PROGRESS_WAITING_INVOICE]: 'Waiting For Invoice',
    [PROGRESS_COMPLETED]: 'Completed',
};

export const PROGRESS_STATUS_ICON = {
    [PROGRESS_OPEN]: '🆕',
    [PROGRESS_ON_HOLD]: '⏸️',
    [PROGRESS_IN_PROGRESS]: '🔧',
    [PROGRESS_IN_REVIEW]: '🔍',
    [PROGRESS_WAITING_PARTS]: '⚙️',
    [PROGRESS_WAITING_COST]: '💰',
    [PROGRESS_WAITING_INVOICE]: '🧾',
    [PROGRESS_COMPLETED]: '✅',
};

export const getProgressStatus = (idx) => {
    return PROGRESS_STATUS[idx] || "Unknown";
};

export const getProgressStatusFilters = (includeAll = true) => {
    const filters = Object.entries(PROGRESS_STATUS).map(([value, label]) => ({
        value: parseInt(value),
        label: PROGRESS_STATUS_ICON[value] + " " + label
    }));
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const PRIORITY_CRITICAL = 1;
export const PRIORITY_HIGH = 2;
export const PRIORITY_MEDIUM = 3;
export const PRIORITY_LOW = 4;
export const PRIORITY_VERY_LOW = 5;

export const PRIORITY_COLORS = {
    [PRIORITY_CRITICAL]: "#d32f2f",
    [PRIORITY_HIGH]: "#ed6c02",
    [PRIORITY_MEDIUM]: "#FFBC0E",
    [PRIORITY_LOW]: "#2e7d32",
    [PRIORITY_VERY_LOW]: "#757575"
};

export const getPriorityFilters = (includeAll = false) => {
    const filters = [
        { value: PRIORITY_VERY_LOW, label: getPriority(PRIORITY_VERY_LOW) },
        { value: PRIORITY_LOW, label: getPriority(PRIORITY_LOW) },
        { value: PRIORITY_MEDIUM, label: getPriority(PRIORITY_MEDIUM) },
        { value: PRIORITY_HIGH, label: getPriority(PRIORITY_HIGH) },
        { value: PRIORITY_CRITICAL, label: getPriority(PRIORITY_CRITICAL) },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
};

export const getPriority = (idx) => {
    switch (idx) {
        case PRIORITY_CRITICAL:
            return "Critical";
        case PRIORITY_HIGH:
            return "High";
        case PRIORITY_MEDIUM:
            return "Medium";
        case PRIORITY_LOW:
            return "Low";
        case PRIORITY_VERY_LOW:
            return "Very Low";
        default:
            return "Unknown";
    }
};

export const PriorityIcon = (level) => {
    switch (level) {
        case PRIORITY_VERY_LOW:
            return '⚪';
        case PRIORITY_LOW:
            return '🟢';
        case PRIORITY_MEDIUM:
            return '🟡';
        case PRIORITY_HIGH:
            return '🟠';
        case PRIORITY_CRITICAL:
            return '🔴';
        default:
            return null;
    }
};

export const PM_ACTIVE = "Planned"
export const PM_INACTIVE = "Paused"

export const STATUS_APPROVED = 10;
export const STATUS_PENDING = 80;
export const STATUS_REJECTED = 90;
export const STATUS_COMPLETED = 100;

export const getWorkOrderStatusFilters = (includeAll = false) => {
    const filters = [
        { value: STATUS_APPROVED, label: "Approved" },
        { value: STATUS_PENDING, label: "Pending" },
        { value: STATUS_REJECTED, label: "Rejected" },
        { value: STATUS_COMPLETED, label: "Completed" },
    ];
    return includeAll ? [AllFilterOptions, ...filters] : filters;
}

export const WorkOrderType = {
    REACTIVE: "reactive",
    PREVENTIVE: "preventive",
}

export const WORK_ORDER_ACTION = {
    SCAN_SPAREPART: 'scan_sparepart',
    STATUS_CHANGE: 'status_change',
    PROGRESS_CHANGE: 'progress_change',
    ASSIGN: 'assign',
    PRIORITY_CHANGE: 'priority_change',
    ATTACH_SPAREPART: 'attach_sparepart',
    UPDATE_SPAREPART_QUANTITY: 'update_sparepart_quantity',
    DETACH_SPAREPART: 'detach_sparepart',
    DUPLICATED: 'duplicated',
    DUE_DATE_CHANGE: 'due_date_change',
    WORK_TYPE_CHANGE: 'work_type_change',
    START_DATE_CHANGE: 'start_date_change',
    IMAGE_CHANGE: 'image_change'
};